import * as types from '../actions/types'

const initialState = {
  newPlace: {
    neighborhood: '',
    city: '',
    provincy: '',
  },
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.FETCH_DATA_BY_CEP:
      return { ...state, newPlace: payload }
    default:
      return state
  }
}
